import config from './config';

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }

    const error = new Error(response.statusText);
    error.response = response;
    throw error;
}

class UAS {
    constructor() {
        this.apiKey = config.env.uas.apiKey;
        this.env = config.env.uas.env;
        this.domainSuffix = 'co.uk';
    }

    create(opts) {
        console.log('New UAS lib create', opts);
        const activityType = opts.activityType;
        delete opts.activityType;

        const subdomain = ['activity'];
        if (this.env !== 'live') {
            subdomain.push(this.env);
        }

        return fetch(`https://${subdomain.join('.')}.api.bbc.${this.domainSuffix}/my/${activityType}`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'X-API-KEY': this.apiKey,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(opts)
        }).then(checkStatus);
    }
}

const uasclientlib = new UAS();

export function addEvent(resource, action = 'followed') {
    return uasclientlib.create({
        activityType: 'follows',
        resourceDomain: resource.domain,
        resourceType: resource.type,
        resourceId: resource.id,
        action,
        metaData: {
            source: 'notifications'
        }
    });
}



/** WEBPACK FOOTER **
 ** ./assets/js/uas.js
 **/